import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-4 text-white">
      <div className="w-full max-w-md border border-white/10 bg-[#111111] p-8 text-center sg-fade" data-testid="payment-cancel">
        <XCircle size={40} className="mx-auto text-[#FF7F00]" />
        <h1 className="mt-4 font-head text-xl font-bold">Checkout canceled</h1>
        <p className="mt-1 text-sm text-gray-500">No charge was made. You can subscribe whenever you're ready.</p>
        <button data-testid="cancel-back" onClick={() => nav("/paywall")}
          className="mt-5 rounded-sm bg-[#00F0FF] px-5 py-2 font-mono-sg text-xs font-bold text-black hover:bg-[#00F0FF]/80">
          Back to plans
        </button>
      </div>
    </div>
  );
}
